<template>
  <div>
    <v-card class="mx-auto">
      <v-card-title>
      Filtro de acceso
      </v-card-title>
      <v-card-text>
        <div>Seleccione un cliente para verificar su membresia</div>
        <model-select
          :options="clientes"
          v-model="cliente"
          class="use-keyboard-input"
          @input="getCliente()"
          placeholder="Seleccione un cliente"
        >
        </model-select>
      </v-card-text>
    </v-card>
    <v-row v-if="clienteData" class="mt-4">
      <v-col class="cols-12 col-xs-12 col-sm-12 col-md-6">
        <v-card class="mx-auto" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">
                <div class="overline mb-4">Información del cliente</div>
                {{ clienteData.Nombres }} {{ clienteData.Apellidos }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar tile size="80" color="white">
              <v-avatar size="56">
                <img alt="user" src="../../assets/img/iconUser.png" />
              </v-avatar>
            </v-list-item-avatar>
          </v-list-item>
          <v-list-item v-show="false">
            <v-list-item-content>
              <v-list-item-title
                >Correo: {{ clienteData.Correo }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-show="false">
            <v-list-item-content>
              <v-list-item-title
                >Telefono:
                {{
                  clienteData.Telefonos ? clienteData.Telefonos[0] : ""
                }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="false">
            <v-list-item-content>
              <v-list-item-title
                >Grupo de usuario:
                {{
                  this.$pgsHelper.getById(gruposCliente, "id", clienteData.Grupo)
                    .Nombre
                }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="false">
            <v-list-item-content>
              <v-list-item-title
                >Membresia:
                {{
                  this.$pgsHelper.getById(
                    data_membresias,
                    "id",
                    clienteData.ExtraData.Membresia.Tipo
                  ).Nombre
                }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col class="cols-12 col-xs-12 col-sm-12 col-md-6">
        <v-card v-if="clienteData.Acceso" class="mx-auto" color="#37904c" dark>
          <v-card-title>
            <v-icon large left> mdi-account-check </v-icon>
            <span class="title font-weight-light">Acceso permitido</span>
          </v-card-title>

          <v-card-text class="headline font-weight-bold">
            El acceso para el cliente {{ clienteData.Nombres }}
            {{ clienteData.Apellidos }} está permitido
          </v-card-text>
        </v-card>
        <v-card v-if="!clienteData.Acceso"  class="mx-auto" color="#f77474" dark>
          <v-card-title>
            <v-icon large left> mdi-alert-circle </v-icon>
            <span class="title font-weight-light">Acceso Denegado</span>
          </v-card-title>

          <v-card-text class="headline font-weight-bold">
            El acceso para el cliente {{ clienteData.Nombres }}
            {{ clienteData.Apellidos }} está denegado, cualquier aclaración
            contacte al administrador del club
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import Cliente from "../../clases/Cliente.js"
export default {
  name: "Miembros",
  components: {
    ModelSelect,
  },
  data() {
    return {
      cliente: "",
      clienteData: "",
      data_membresias: [],
      gruposClient: [],
    };
  },
  computed: {
    clientes() {
      let data = Cliente.getClientsList();

      data.forEach((cliente) => {
        cliente.value = cliente.Id;
        cliente.text = cliente.getNombreCompleto();
        cliente.Acceso = ((cliente.ExtraData)?((cliente.ExtraData.Membresia)?cliente.ExtraData.Membresia.Membresia:null):null);
      });

      return data;
    },
  },
  methods: {
    getCliente(id) {
      let cliente = this.$pgsHelper.getById(
        this.clientes,
        "Id",
        this.cliente
      );
      this.clienteData = cliente;
    },
    async getUserGroups() {
      const data = await this.$store.getters.getFirebaseApp.database
        .queryBuilder("PDV/GruposCliente")
      let arrayGrupos = Object.entries(data.val());

      let grupos = [];
      arrayGrupos.forEach(function (element) {
        grupos.push({ id: element[0], Nombre: element[1]["Nombre"] });
      });

      this.gruposCliente = grupos;
    },
    async getMembresias() {
      const data = await this.$store.getters.getFirebaseApp.database
        .queryBuilder("MBS/Membresias/Coleccion");
      if (data.exists()) {
        let arrayGrupos = Object.entries(data.val());

        let grupos = [];
        arrayGrupos.forEach(function (element) {
          grupos.push({ id: element[0], Nombre: element[1]["Nomb"] });
        });
        this.data_membresias = grupos;
      }
    },
  },
  beforeMount: function () {},
  mounted: function () {
    this.getUserGroups();
    this.getMembresias();
  },
};
</script>




